<tcm-main-frame [attr.data-qa]="'main-control1'"
                [isLoading]="isLoading"
                [titleKey]="titleKey"
                [hideCommands]="hideCommands">

    <ng-container title>
        <ng-content select="[title]" [attr.data-qa]="'main-control2'"></ng-content>
    </ng-container>

    <div commands class="search-action-panel" [attr.data-qa]="'main-control3'">
        <div [attr.data-qa]="'main-control4'">
            <ng-content select="[commands]" [attr.data-qa]="'main-control5'"></ng-content>
        </div>
        <search-common-commands [attr.data-qa]="'main-control6'"
                                [useExport]="useExport"
                                [useGlobalSearch]="useGlobalSearch"
                                [useAdvancedSearch]="useAdvancedSearch"
                                [(searchTerm)]="searchTerm"
                                (searchTermChange)="searchTermChange.emit($event)"
                                (print)="print.emit($event)"
                                [(showAdvanced)]="showAdvanced"
                                (showAdvancedChange)="onShowAdvancedChange()"
                                [globalSearchPlaceholder]="globalSearchPlaceholder"
                                [showPrint]="showPrint">
            <ng-container after-export-area>
                <ng-content select="[after-export-area]" [attr.data-qa]="'main-control7'"></ng-content>
            </ng-container>
        </search-common-commands>
    </div>

    <div class="search-body" body [attr.data-qa]="'main-control8'">
        <div class="resync-container">
            <ng-content select="[resyncRequired]"></ng-content>
        </div>
        <div class="content-container" [attr.data-qa]="'main-control9'">
            <div class="results-container scrollable-content" [attr.data-qa]="'main-control10'">
                <ng-content select="[results-area]" [attr.data-qa]="'main-control11'"></ng-content>
            </div>

            <div class="right-sidebar-container" [attr.data-qa]="'main-control12'" [class.opened]="showAdvanced" #rightSideBarContainer>
              <div class="advance-search-content scrollable-content">
                <ng-content select="[right-sidebar-area]" [attr.data-qa]="'main-control13'"></ng-content>
                </div>
            </div>
        </div>
    </div>
</tcm-main-frame>
